<template>
  <div class="fp-step fp-step-options">
    <div class="fp-step-header">
      <button type="button" class="fp-back-btn" @click="$emit('go-back')" t_label="btn_emp2_Back_ForgotPasswordOptions">
        <img 
          src="https://cdn.adsalecdn.com/EMP/2-0/BuyerIdx/All_Categories.svg" 
          alt="back" 
          class="fp-back-icon"
        />
      </button>
      <h1 class="fp-step-title">{{ $t('lbl_emp2_ForgotPassword') }}?</h1>
    </div>

    <div class="fp-form-group">
      <div class="fp-info-text" v-html="$t('lbl_emp2_IfConnectedOtherLoginMethods')"></div>
    </div>

    <div class="fp-form-group">
      <AlternativeLoginButtons
        :buttons="[
          { key: 'mobile', label: $t('lbl_emp2_LoginWithMobile'), withIndicator: false },
          { key: 'email', label: $t('lbl_emp2_LoginWithEmail'), withIndicator: false }
        ]"
        @switch="$emit('switch-login', $event)"
      />
    </div>

    <Divider />

    <div class="fp-form-group">
      <div class="fp-info-text" v-html="$t('lbl_emp2_IfAdminMobileOrEmail')"></div>
    </div>

    <div class="fp-form-group">
      <AlternativeLoginButtons
        :buttons="[
          { key: 'forgot-password-mobile', label: $t('lbl_emp2_RetrievePasswordViaMobile'), withIndicator: false },
          { key: 'forgot-password-email', label: $t('lbl_emp2_RetrievePasswordViaEmail'), withIndicator: false }
        ]"
        @switch="$emit('switch-login', $event)"
      />
    </div>
    
    <Divider />

    <div class="fp-form-group">
      <div class="fp-info-text" v-html="$t('lbl_emp2_IfNotConnectedOtherLoginMethods')"></div>
      <AlternativeLoginButtons
        :buttons="[
          { key: 'contact-us', label: $t('lbl_emp2_ContactUs'), withIndicator: false }
        ]"
        @switch="$emit('switch-login', $event)"
      />
    </div>
  </div>
</template>

<script>
import Divider from '../Common/Divider.vue';
import AlternativeLoginButtons from '../Common/AlternativeLoginButtons.vue';

export default {
  name: 'ForgotPasswordOptions',
  components: {
    Divider,
    AlternativeLoginButtons
  }
};
</script>

<style>
@import '../Common/new-login-shared.css';
</style>

<style scoped>
.fp-step-options {
  gap: 24px !important;
}
</style>

